import { Map } from 'immutable';

import { updateListingScore } from '@/utils/product/score';
import { replaceOperation } from '@/utils/product/operations';
import { tagsFromArray } from '@/utils/tags';
import { editTags } from '@/utils/edit/tags';

import { ATTRIBUTE } from '@/constants/attributes';
import { VALUE } from '@/constants/product';
import { EMPTY } from '@/constants';
import { FORM } from '@/constants/forms';

export function tags({ operation, product, ...rest }) {
  const updates = editTags({
    operation: operation.get('type'),
    product: product.set(FORM.TAGS, Map({ [VALUE]: tagsFromArray(operation.get('value')) })),
  });

  if (updates.product.hasIn(['score', ATTRIBUTE.TAGS])) {
    const { shop, userFeatures } = rest;
    updates.product = updateListingScore({ product: updates.product, shop, userFeatures });
  }

  return {
    ...rest,
    product: updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
